import Message from 'messaging/models/Message'
import { computed, makeObservable } from 'mobx'

export interface MessageContentViewModel {
  message: Message
  activate?(): Promise<void>
  deactivate?(): Promise<void>
}

export default class MessageViewModel {
  constructor(
    public message: Message,
    public content: MessageContentViewModel,
  ) {
    makeObservable(this)
  }

  /**
   * Message type.
   */
  @computed
  get messageType() {
    return this.message.messageType
  }

  /**
   * Message content type.
   */
  @computed
  get contentType() {
    return this.message.content.type
  }

  async activate() {
    await this.content.activate?.()
  }

  async deactivate() {
    await this.content.deactivate?.()
  }
}
